<template>
  <div class="sidebar"
       :data-color="backgroundColor"
       :data-active-color="activeColor">
    <div class="logo sidebar-logo-top">
      <a class="simple-text logo-mini">
        <div class="logo-img">
          <img :src="clientLogo" alt="">
        </div>
      </a>
      <a class="simple-text logo-normal">
        {{title}}
      </a>
    </div>
    <div class="absolute z-10 logo-border border-b border-gray-500 px-2"></div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot>

      </slot>
      <ul class="nav main__links">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
      <ul class="nav bottom__links">
        <slot name="bottom-links"></slot>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        default: 'CARRIÈRE.NU',
        description: 'Sidebar title'
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar background color (white|brown|black)'
      },
      activeColor: {
        type: String,
        default: 'danger',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar active text color (primary|info|success|warning|danger)'
      },
      logo: {
        type: String,
        default: '',
        description: 'Sidebar Logo'
      },
      sidebarLinks: {
        type: Array,
        default: () => [],
        description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      }
    },
    computed: {
      clientLogo() {
        return this.logo || ``
      }
    },
    beforeDestroy() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style lang="scss">
  @import "~@/assets/sass/paper/variables";
  @import "~@/assets/sass/paper/mixins";

  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu {
      display: none;
    }
  }
  .sidebar .logo.sidebar-logo-top {
    display: flex;
    align-items: center;
    padding-top: 0;
  }
  .sidebar {
    .internal-menu {
      display: none;
    }
    .external-menu {
      position: absolute;
      right: -48px;
      opacity: 0;
      transition: opacity .2s;
      z-index: -1;
    }

    .logo-normal {
      width: auto;
      height: auto;
      margin-left: 10px;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .logo-mini img {
      height: auto !important;
      border-radius: 0;
      max-height: 100%;
    }
    .sidebar-wrapper {
      display: flex;
      flex-direction: column;
    }

    .main__links {
      flex: 1;
    }
    .logo-border {
      width: calc(100% - 30px);
      margin-left: 15px;
    }
  }
  @media screen and (min-width: 992px) {
    .sidebar {
      .internal-menu {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        margin-top: 2px;
        padding-right: 10px;
        svg {
          width: 20px;
        }
      }
    }
    .sidebar-mini {
      .internal-menu {
        display: none;
      }

      .external-menu{
        opacity: 1;
        z-index: 100;
      }
    }
    .sidebar-mini .sidebar:hover {
      .internal-menu {
        display: flex;
      }
    }
  }
</style>
